import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, RefreshCcw } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from './contexts/LanguageContext';
import { useCart } from './contexts/CartContext';
import { t } from './translations';

const OrderFailure: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { restoreCart } = useCart();

  useEffect(() => {
    const saved = localStorage.getItem('pending_payment_cart');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          // Защита от подделки localStorage: оставляем только items с правдоподобной
          // структурой. Цены/PIN всё равно перепроверяются сервером, но пускать
          // мусор в корзину тоже не хочется.
          const clean = parsed
            .filter((it: unknown): it is Record<string, unknown> =>
              !!it && typeof it === 'object'
              && typeof (it as any).id === 'number'
              && typeof (it as any).price === 'number'
              && (it as any).price >= 0
              && Number.isInteger((it as any).quantity)
              && (it as any).quantity > 0
              && (it as any).quantity <= 99
            )
            .slice(0, 50);
          if (clean.length > 0) restoreCart(clean as any);
        }
      } catch (e) {
        console.error('Failed to restore cart:', e);
      }
      localStorage.removeItem('pending_payment_cart');
    }
  }, []);

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full bg-card rounded-3xl shadow-xl p-8 text-center"
      >
        <div className="w-20 h-20 bg-danger-bg-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-danger-fg" />
        </div>
        <h1 className="text-2xl font-black text-ink mb-2 uppercase tracking-tight">
          {t('checkout.paymentError', language)}
        </h1>
        <p className="text-ink-soft mb-8 font-medium">
          {t('checkout.paymentErrorDesc', language)}
        </p>
        <button
          onClick={() => navigate('/')}
          className="w-full bg-[var(--btn-dark-bg)] text-white py-4 rounded-2xl font-black uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-[var(--btn-dark-bg-hover)] transition-colors"
        >
          <RefreshCcw className="w-5 h-5" />
          {t('checkout.tryAgain', language)}
        </button>
      </motion.div>
    </div>
  );
};

export default OrderFailure;
